import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type IInboxTreeCombine, type INodeModel } from 'entities/Inbox'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { Inbox } from 'entities/Inbox/model/Inbox'
import { SmartView } from 'entities/SmartViews/model/SmartView'
import {
  MenuCardInbox,
  MenuCardInboxGroup,
  MenuCardInboxGroupCreate,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuCard'
import { MenuCardSmartViewInbox } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuCard/MenuCardSmartViewInbox/MenuCardSmartViewInbox'

type PropsMenuItemTree = {
  rootId: string | number
  node: INodeModel<IInboxTreeCombine>
  onToggle: () => void
  isOpen: boolean
  hasChild: boolean
  onClickItemTree?: () => void
}

export const MenuCardTree: FC<PropsMenuItemTree> = observer(
  ({ node, onToggle, isOpen, hasChild, onClickItemTree }) => {
    const { data, droppable, groupInbox } = node
    const { inboxesStore } = useEntitiesContext()
    const inbox = inboxesStore.getItem(data?.id) || data

    if (!inbox) return null

    if (inbox instanceof GroupInbox && inbox.isCreateGroup) {
      return <MenuCardInboxGroupCreate item={inbox} />
    }

    if (inbox instanceof SmartView) {
      return <MenuCardSmartViewInbox item={inbox} onClickItemTree={onClickItemTree} />
    }

    if (inbox instanceof GroupInbox) {
      return (
        <MenuCardInboxGroup
          item={inbox}
          onToggle={onToggle}
          isOpen={isOpen}
          droppable={droppable}
          hasChild={hasChild}
          onClickItemTree={onClickItemTree}
        />
      )
    }

    if (inboxesStore.isGroupChild(inbox.id) && !groupInbox) return null

    if (inbox instanceof Inbox) {
      if (groupInbox instanceof GroupInbox) {
        return (
          <MenuCardInbox item={inbox} groupInbox={groupInbox} onClickItemTree={onClickItemTree} />
        )
      }

      return <MenuCardInbox item={inbox} onClickItemTree={onClickItemTree} />
    }

    return null
  }
)
